import React from "react"
import { COLORS } from "../../utilities/Constants"

// Primitives des cartes de référence (lecture seule) des fiches V2 :
// texte clé→valeur, pas d'inputs. Extraites d'AtelierClientVehiculeCardV2
// pour servir les 3 fiches (règle : même modèle UI partout).

// Ligne clé→valeur uniforme du rail de référence. Masquée si la valeur est vide.
export const RefRow = ({ label, value }) => {
	if (value === undefined || value === null || value === "") return null
	return (
		<div
			style={{
				display: "flex",
				alignItems: "baseline",
				gap: 12,
				padding: "6px 0",
			}}
		>
			<span
				style={{
					fontSize: 11,
					fontWeight: 500,
					color: COLORS.textLight,
					textTransform: "uppercase",
					letterSpacing: "0.04em",
					minWidth: 72,
					flexShrink: 0,
				}}
			>
				{label}
			</span>
			<span
				style={{
					flex: 1,
					fontSize: 14,
					fontWeight: 500,
					color: COLORS.text,
					fontVariantNumeric: "tabular-nums",
					wordBreak: "break-word",
				}}
			>
				{value}
			</span>
		</div>
	)
}

// Section interne (titre + lignes) d'une carte de référence : pas de wrapper carte,
// pour pouvoir empiler plusieurs sections dans une seule carte. `divider` ajoute
// un espace au-dessus pour séparer la section précédente.
export const RefSection = ({ title, action = null, divider = false, children }) => (
	<div style={divider ? { marginTop: 20 } : {}}>
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: 8,
				marginBottom: 14,
				paddingBottom: 12,
				borderBottom: `1px solid ${COLORS.border}`,
			}}
		>
			<span
				style={{
					fontSize: 11,
					fontWeight: 600,
					color: COLORS.textLight,
					letterSpacing: "0.1em",
					textTransform: "uppercase",
				}}
			>
				{title}
			</span>
			{action}
		</div>
		{children}
	</div>
)
